import React from 'react'

export default function Placeholder(props) {
  return (
    <div onClick={props.onComplete}>
      The component {props.type} has not been created yet. Click here to advance to the next step.
    </div>
  )
}
